var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2C2.44772 2 2 2.44772 2 3V19C2 19.5523 2.44772 20 3 20H15C15.5523 20 16 19.5523 16 19V3C16 2.44772 15.5523 2 15 2H3ZM0 3C0 1.34315 1.34315 0 3 0H15C16.6569 0 18 1.34315 18 3V19C18 20.6569 16.6569 22 15 22H3C1.34315 22 0 20.6569 0 19V3Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3C9.55228 3 10 3.44772 10 4V4.90909H12.3333C12.8856 4.90909 13.3333 5.35681 13.3333 5.90909C13.3333 6.46138 12.8856 6.90909 12.3333 6.90909H10V10H10.6667C11.5802 10 12.4367 10.3967 13.0537 11.0698C13.6681 11.7401 14 12.6319 14 13.5455C14 14.459 13.6681 15.3508 13.0537 16.0211C12.4367 16.6942 11.5802 17.0909 10.6667 17.0909H10V18C10 18.5523 9.55228 19 9 19C8.44772 19 8 18.5523 8 18V17.0909H5C4.44772 17.0909 4 16.6432 4 16.0909C4 15.5386 4.44772 15.0909 5 15.0909H8V12H7.33333C6.41981 12 5.56332 11.6033 4.94626 10.9302C4.33188 10.2599 4 9.36814 4 8.45455C4 7.54096 4.33188 6.64915 4.94626 5.97891C5.56332 5.30576 6.41981 4.90909 7.33333 4.90909H8V4C8 3.44772 8.44772 3 9 3ZM8 6.90909H7.33333C7.00918 6.90909 6.67868 7.04879 6.42057 7.33036C6.15979 7.61485 6 8.01794 6 8.45455C6 8.89115 6.15979 9.29424 6.42057 9.57873C6.67868 9.86031 7.00918 10 7.33333 10H8V6.90909ZM10 12V15.0909H10.6667C10.9908 15.0909 11.3213 14.9512 11.5794 14.6696C11.8402 14.3851 12 13.9821 12 13.5455C12 13.1089 11.8402 12.7058 11.5794 12.4213C11.3213 12.1397 10.9908 12 10.6667 12H10Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotations);
export default __webpack_public_path__ + "static/media/quotations.b031213c9edb13917cd4881b7c17ba4b.svg";
export { ForwardRef as ReactComponent };